<template>
  <div class="mypage" v-if="information">
    <h1 class="common__main-title">Information</h1>
    <div class="common__sub-title">
      <span class="mr-3">{{information.sendDate | ymd}}</span>
      <span>{{information.subject}}</span>
    </div>
    <div class="common__main-contener mb-4">
      <div class="common__main-content" style="white-space:pre-wrap;">{{information.body}}</div>
    </div>
    <div class="d-flex justify-content-between">
      <b-button
        pill
        variant="secondary"
        :to="{name:'Dashboard'}"
      >
        Back
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  created() {
    this.$store.dispatch(
      'fetchInformation',
      { notificationId: this.$route.params.id },
    );
  },

  computed: {
    information() {
      return this.$store.getters.findInformationById(this.$route.params.id)
    },
  },

  filters: {
    ymd(date) {
      return moment(date, 'YYYYMMDD').format('YYYY/MM/DD')
    },
  },
}
</script>

<style scoped>
.mypage__container {
  background: #DDEAF6;
  padding: 40px;
  margin-bottom:30px;
}
</style>
